import { useEffect } from "react"
import useClickListener from "../../utils/hooks/useClickListener"
import { containsValidTargetClass } from "./DatalayerMethods"

const DatalayerArticlePage = props => {

  const datalayerArticleSocialShare = event => {
    if (
      containsValidTargetClass(
        ["blog-article__share-section-icon"],
        event?.target?.classList
      )
    ) {
      const postAuthorsCollection = [...document?.querySelectorAll(".blog-article__meta-section-text--authors")].map(author => author?.innerText);
      let authorsText = ``;
      postAuthorsCollection?.forEach(author => { authorsText += `${author}, ` });
      
      window.dataLayer.push({
        event: "blog_article_social_share",
        sharing_platform: event?.target?.dataset?.sharetype,
        post_title: document?.querySelector("h1")?.textContent,
        post_url: event?.target?.href,
        post_length: document?.querySelector(".blog-article__meta-section-text--read-time")?.textContent,
        post_author: authorsText,
        post_publish_date: document?.querySelector(".blog-article__meta-section-text--publish-date")?.textContent,
      })
    }
  }
  // add handler if relevant listener elem exists
  let shareQuery = ""
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    shareQuery = document?.querySelectorAll(".blog-article__share-section-icon").length > 0
  }
  useClickListener(datalayerArticleSocialShare, shareQuery)
}

export default DatalayerArticlePage
